import { Footer, Menu, PageContainer, Seo } from "~components";
import { Layout } from "~components/common/Layout";
import { EventsCalendar } from "~components/calendar/calendar";
import { useRouter } from "next/router";
import { CalendarHomepageCustomizationDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";
import { SlateRenderer } from "~components/common/Slate/SlateRenderer";
import { Box, Divider, Text, VStack } from "flicket-ui";

const CalendarHomePage = () => {
  const router = useRouter();

  const { data } = useQuery(CalendarHomepageCustomizationDocument);

  const customization = data?.calendarHomepageCustomization;

  function handleSelectEvent(eventId: string) {
    void router.push({
      pathname: `/events/[eventId]/reservation`,
      query: {
        ...router.query,
        eventId: eventId,
      },
    });
  }

  return (
    <>
      <Seo title={customization?.title || "Events calendar"} />

      <Layout
        layoutType="main"
        css={`
          padding-top: 0 !important;
        `}
      >
        <Menu sticky={false} />

        <PageContainer
          bannerImage={customization?.banner || null}
          footer={<Footer />}
          containerProps={{
            pt: 3,
            minHeight: { _: 0, md: "320px" },
          }}
        >
          <VStack gap="1/2">
            {customization?.title && (
              <Text variant="header.L" as="h1">
                {customization.title}
              </Text>
            )}

            {customization?.description && (
              <SlateRenderer value={customization.description} />
            )}
            
            {(customization?.title || customization?.description) && (
              <Divider mt={3} />
            )}
          </VStack>

          <Box mt={4}>
            <EventsCalendar handleSelectEvent={handleSelectEvent} />
          </Box>
        </PageContainer>
      </Layout>
    </>
  );
};

export default CalendarHomePage;
